// src/ui/Pagination.jsx
import React from "react";

export default function Pagination({ currentPage, pageCount, onPageChange }) {
  if (pageCount <= 1) return null;

  const pages = Array.from({ length: pageCount }, (_, i) => i + 1);

  return (
    <nav className="flex items-center gap-2">
      <button
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        className="rounded-lg border px-3 py-1.5 text-sm hover:bg-gray-50"
        disabled={currentPage === 1}
      >
        Prev
      </button>

      <ul className="flex items-center gap-1">
        {pages.map((p) => (
          <li key={p}>
            <button
              onClick={() => onPageChange(p)}
              className={`rounded-lg border px-3 py-1.5 text-sm ${
                p === currentPage ? "bg-black text-white border-black" : "hover:bg-gray-50"
              }`}
            >
              {p}
            </button>
          </li>
        ))}
      </ul>

      <button
        onClick={() => onPageChange(Math.min(pageCount, currentPage + 1))}
        className="rounded-lg border px-3 py-1.5 text-sm hover:bg-gray-50"
        disabled={currentPage === pageCount}
      >
        Next
      </button>
    </nav>
  );
}
